import axios from 'axios';
import { setupAuthInterceptor, retryWithBackoff } from '../common';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.clients_api.client_reservations;

// Helper function to configure the Axios instance with auth interceptor
const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
}));

/** Fetch a single reservation by its ID */
export const getReservationById = async (reservationId: number) => {
    return await retryWithBackoff(() => api.get(`/GetReservationById/${reservationId}`)) as any;
};

// /GetSalonsForReservation/<int:local_id>

export const getSalonsForReservation = async (localId:number) => {
    return await retryWithBackoff(() => api.get(`/GetSalonsForReservation/${localId}`)) as any;
}


//@ns.route('/GetAvailableReservationSlots/<int:local_id>')

export const getAvailableReservationSlots = async (localId:number, reservationDate:string, nPeople:number, salonId:number | null) => {
    return await retryWithBackoff(() => api.post(`/GetAvailableReservationSlots/${localId}`,
         {reservation_date: reservationDate,
             n_people: nPeople,
              salon_id: salonId})) as any;
}

export const getAvailableTablesManual = async (
    localId: number,
    reservationDate: string,
    salonId: number | null
) => {
    return await retryWithBackoff(() => api.post(`/GetAvailableTablesManual/${localId}`, {
        reservation_date: reservationDate,
        salon_id: salonId,
    })) as any;
};

// /GetAllClientReservationsByLocalId/<int:local_id>

export const getAllClientReservationsByLocalId = async (localId:number) => {
    return await retryWithBackoff(() => api.get(`/GetAllClientReservationsByLocalId/${localId}`)) as any;
}

export const getReservationsFromCurrentSessionId = async (localId:number) => {
    return await retryWithBackoff(() => api.get(`/GetReservationsFromCurrentSessionId/${localId}`)) as any;
}




export const createReservation = async (local_id:number,
    reservation_date:string,
    n_people:number | null,
    init:number | null,
    mesa_id:number | null,
    client_id:number | null,
    userId:number | null,
    client_name:string | null,
    email:string | null,
    phone_number:string | null,
    note:string) => {
    return await retryWithBackoff(() => api.post('/CreateReservation', {
        "local_id": local_id,
        "reservation_date": reservation_date,
        "n_people": n_people,
        "init": init,
        "mesa_id": mesa_id,
        "client_id": client_id,
        "user_id": userId, // <-- ahora se envía al backend
        "client_name": client_name,
        "email": email,
        "phone_number": phone_number,
        "description": note
    })) as any;
}

// /GetTodayReservationsByLocalIdAndDate/<int:local_id>/<string:date> with date in format YYYY-MM-DD

export const getTodayReservationsByLocalIdAndDate = async (localId:number, date:string) => {
    return await retryWithBackoff(() => api.get(`/GetTodayReservationsByLocalIdAndDate/${localId}/${date}`)) as any;
}

export const getTodayReservationsByLocalIdAndDateRange = async (localId:number, startDate:string, endDate:string) => {
    return await retryWithBackoff(() => api.get(`/GetTodayReservationsByLocalIdAndDateRange/${localId}/${startDate}/${endDate}`)) as any;
}

/**
 * 
# Parser para obtener mesas disponibles en un slot específico
available_tables_slot_parser = reqparse.RequestParser()
available_tables_slot_parser.add_argument('reservation_date', type=str, required=True)
available_tables_slot_parser.add_argument('slot', type=int, required=True)
available_tables_slot_parser.add_argument('n_people', type=int, required=True)
available_tables_slot_parser.add_argument('duration_slots', type=int, required=False, default=8)
available_tables_slot_parser.add_argument('salon_id', type=int, required=False)

@ns.route('/GetAvailableTablesForSlot/<int:local_id>')
@ns.param('local_id', 'The local identifier')
class GetAvailableTablesForSlot(Resource):
    @ns.doc('get_available_tables_for_slot', description='Get all available tables for a specific date and time slot')
    def post(self, local_id):
        """
        Get available tables for a specific time slot
        
        Returns a list of tables that are free for the requested time slot and duration.
        Each table includes: mesa_id, mesa_number, tag, capacity, and salon_id.
        Filters tables by capacity to ensure they can accommodate n_people.
        """
        args = available_tables_slot_parser.parse_args()
        helper = ClientReservationHelper()
        ok, payload, status = helper.get_available_tables_for_slot(
            local_id=local_id,
            date_str=args['reservation_date'],
            slot=args['slot'],
            n_people=args['n_people'],
            duration_slots=args.get('duration_slots', 8),
            salon_id=args.get('salon_id')
        )
        return (payload, status)
 */

export const getAvailableTablesForSlot = async (
    localId: number,
    reservationDate: string,
    slot: number,
    nPeople: number,
    durationSlots: number = 8,
    salonId: number | null = null
) => {
    return await retryWithBackoff(() => api.post(`/GetAvailableTablesForSlot/${localId}`, {
        reservation_date: reservationDate,
        slot: slot,
        n_people: nPeople,
        duration_slots: durationSlots,
        salon_id: salonId
    })) as any;
};

// /ApproveReservation/<int:reservation_id>

export const approveReservation = async (reservationId:number) => {
    return await retryWithBackoff(() => api.post(`/ApproveReservation/${reservationId}`)) as any;
}

// /RejectReservation/<int:reservation_id>

export const rejectReservation = async (reservationId:number) => {
    return await retryWithBackoff(() => api.post(`/RejectReservation/${reservationId}`)) as any;
}

// /MarkReservationAsAttended/<int:reservation_id>

export const markReservationAsAttended = async (reservationId:number) => {
    return await retryWithBackoff(() => api.post(`/MarkReservationAsAttended/${reservationId}`)) as any;
}

// /ConfirmReservation/<int:reservation_id>

export const confirmReservation = async (reservationId:number) => {
    return await retryWithBackoff(() => api.post(`/ConfirmReservation/${reservationId}`)) as any;
}

export const arrivedReservation = async (reservationId:number) => {
    return await retryWithBackoff(() => api.post(`/ArrivedReservation/${reservationId}`)) as any;
}

// /CancelReservation/<int:reservation_id>

export const cancelReservation = async (reservationId:number) => {
    return await retryWithBackoff(() => api.post(`/CancelReservation/${reservationId}`)) as any;
}
